import { ParentTypes } from '@risksmart-app/domain/src/types/consts';
import { NAVIGATION_PARENT_TYPES } from '@risksmart-app/drizzle/src/types/permission.types';

// Sidebar and register guards share one query key and cached visibility batch.
export const NAVIGATION_VISIBILITY_PARENT_TYPES = Object.values(
  ParentTypes
).filter((parentType) => Object.hasOwn(NAVIGATION_PARENT_TYPES, parentType));
